































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { FileSizeCheck } from "@/script/fileManager";
import {mapGetters} from "vuex";
@Component({
    computed: { ...mapGetters(["user"]) },
    components: {},
})
export default class ProfileImgUploader extends Vue {

    private fileName: string = "";

    uploadFile() {
        (this.$refs.profileImg as HTMLElement).click();
    }

    onFileChange(event: { target: { files: any } }) {
        this.inputFile(event.target.files);
        this.fileName =event.target.files[0].name
    }

    inputFile(files: File) {

    }
}
